<template>
  <div class="w-1200">
    <div class="title">支付订单</div>
    <div class="body-content">
      <el-form :model="from" label-width="100px">
        <el-form-item label="支付方式">
          <el-radio-group v-model="from.pay_type">
            <el-radio :label="1">银行汇款</el-radio>
            <el-radio :label="2">扫码支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="pay-info" v-if="from.pay_type == 1">
          <div class="pay-info-item">
            <div class="pay-info-item-title">账户名称</div>
            <div class="pay-info-item-content">{{ pay_name }}</div>
            <el-button
              class="copy-btn"
              type="text"
              @click="handleCopy(pay_name)"
            >
              <i class="el-icon-copy-document"></i
            ></el-button>
          </div>
          <div class="pay-info-item">
            <div class="pay-info-item-title">银行帐号</div>
            <div class="pay-info-item-content">{{ pay_bank }}</div>
            <el-button
              class="copy-btn"
              type="text"
              @click="handleCopy(pay_bank)"
            >
              <i class="el-icon-copy-document"></i
            ></el-button>
          </div>
          <div class="pay-info-item">
            <div class="pay-info-item-title">开户行</div>
            <div class="pay-info-item-content">{{ pay_account }}</div>
            <el-button
              class="copy-btn"
              type="text"
              @click="handleCopy(pay_account)"
            >
              <i class="el-icon-copy-document"></i
            ></el-button>
          </div>
        </div>
        <div class="pay-info" v-if="from.pay_type == 2">
          <div class="pay-info-item">
            <div class="pay-info-item-title">收款码</div>
            <div class="pay-info-item-content">
              <img
                :src="pay_alipay"
                alt=""
                @click="handlePriveImage(pay_alipay)"
              />
            </div>
          </div>
        </div>
        <el-form-item label="付款凭证">
          <ImageUpload
            :value="from.pay_image"
            :maxCount="1"
            @change="handlePayImage"
          />
        </el-form-item>
      </el-form>
      <div class="pay-button">
        <el-button type="plain" @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import gradientButton from "@/components/button/gradient-button.vue";

import { getConfigByKey } from "@/api/modules/common";
import { pay_order } from "@/api/modules/user";
export default {
  name: "pay",
  components: {
    gradientButton,
  },
  data() {
    return {
      id: this.$route.params.id,
      orderId: this.$route.params.order_id,
      from: {
        pay_type: 1,
        pay_image: "",
      },

      pay_name: "",
      pay_account: "",
      pay_bank: "",
      pay_alipay: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 获取配置信息
      getConfigByKey("pay_name").then((res) => {
        this.pay_name = res.data.data.value;
      });
      getConfigByKey("pay_account").then((res) => {
        this.pay_account = res.data.data.value;
      });
      getConfigByKey("pay_bank").then((res) => {
        this.pay_bank = res.data.data.value;
      });
      getConfigByKey("pay_alipay").then((res) => {
        this.pay_alipay = res.data.data.value;
      });
    },
    handleBack() {
      this.$router.back();
    },
    handleCopy(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success({
              message: "复制成功",
              type: "success",
              offset: 100,
            });
          })
          .catch(() => {
            this.$message.error({
              message: "复制失败，请手动复制",
              type: "error",
              offset: 100,
            });
          });
      } else {
        // 兼容老浏览器
        const input = document.createElement("input");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message.success({
            message: "复制成功",
            type: "success",
            offset: 100,
          });
        } catch (e) {
          this.$message.error({
            message: "复制失败，请手动复制",
            type: "error",
            offset: 100,
          });
        }
        document.body.removeChild(input);
      }
    },
    // 预览图片
    handlePriveImage(url) {
      window.open(url, "_blank");
    },
    handlePayImage(e) {
      this.from.pay_image = e[0];
    },
    // 提交订单
    handleSubmit() {
      if (!this.from.pay_image) {
        this.$message.error({
          message: "请上传付款凭证",
          type: "error",
          offset: 100,
        });
        return;
      }
      pay_order(this.orderId, this.from).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            type: "success",
            offset: 100,
          });
          this.$router.push({
            path: "/user/purchase/order",
          });
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            offset: 100,
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  font-weight: 800;
  font-size: 24px;
  color: #00112b;
  margin: 40px 0 20px;
}
.pay-button {
  display: flex;
  text-align: center;
  gap: 20px;
  padding-left: 100px;
}
.body-content {
  padding: 20px 300px 20px;
  background-color: #ffffff;
  .pay-info {
    .pay-info-item {
      display: flex;
      align-items: center;
      text-align: right;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      .pay-info-item-title {
        width: 80px;
        text-align: right;
      }
      .pay-info-item-content {
        margin-left: 30px;
        img {
          width: 150px;
          height: 150px;
        }
      }
      .copy-btn {
        margin-left: 10px;
      }
    }
  }
}
</style>
